<template>
  <div class="container-categ">
    <h1>Gestion de vos catégories</h1>
    <div class="categ-creation">
      <button @click="createCateg"><font-awesome-icon icon="plus" class="icon-add" /> Nouvelle catégorie <i class="bi bi-plus"></i></button>
      <router-link class="text-sm" to="/cms-create"><small>Ajouter un article</small></router-link>
    </div>
    <div class="categ-gestion">
      <ul class="list">
        <li v-for="categ in categList" :key="categ.Id" class="card">
          <div class="card-object">
            <div class="header">
              <span class="title">{{categ.Label}}</span>
            </div>
            <div class="management">

              <button :disabled="categ.CreatorGuid != $store.state.self.guid" title="Editer la catégorie" class="edit" @click="showModalUpdate(categ)"><font-awesome-icon icon="edit" class="icon-edit"></font-awesome-icon></button>
              <button :disabled="categ.CreatorGuid != $store.state.self.guid" title="Supprimer la catégorie" class="trash" @click="showModalDelete(categ)"><font-awesome-icon icon="trash" class="icon-trash"></font-awesome-icon></button>
            </div>

          </div>
        </li>

      </ul>
    </div>
    <div v-if="isDeleting">
      <CmsDeleteCategory @close="close" @deleteCateg="deleteCateg" :categ="selectedCategory"></CmsDeleteCategory>
    </div>
    <div v-if="isUpdating">
      <CmsUpdateCategory @close="close" @updateCateg="updateCateg" :categ="selectedCategory"></CmsUpdateCategory>
    </div>
  </div>

</template>

<script>
  //Import des méthodes et des components
  import { getCategories, createCategory, deleteCategory, updateCategory} from "@/utils/cms"
  import CmsDeleteCategory from "@/components/Cms/CmsDeleteCategory"
  import CmsUpdateCategory from "@/components/Cms/CmsUpdateCategory"
  export default {
    name: "CmsCateg",
    components: {
      CmsDeleteCategory,
      CmsUpdateCategory
    },
    data() {
      return {
        categList: [], //Liste des catégories
        selectedCategory: null, //Catégorie selectionnée pour être passée aux composants
        isDeleting: false, //L'utilisateur est entrain de supprimer ? 
        isUpdating: false //L'utilisateur est entrian de modifier ?
      }

    },
    mounted() {
      this.getListOfCateg() //Récupère la liste des catégories lors de l'entrée de l'utilisateur sur la page
    },
    methods: {
      getListOfCateg() { //Appel à l'api puis stock les catéogires dans la liste
        getCategories().then((response) => {
          this.categList = response;
        })
      },
      createCateg: function () { //Créer une nouvelle catégorie avec un nom par défaut
        createCategory('0. Nouvelle catégorie').then(() => {
          this.getListOfCateg(); //mis à jour des catégories
        });
      },
      showModalDelete(category) { //Affiche le composant de suppression
        this.selectedCategory = category;
        this.isDeleting = true;
      },
      deleteCateg: function () { //supprime une catégorie puis met à jour la liste
        deleteCategory(this.selectedCategory.Id).then(() => {
          this.getListOfCateg();
        })
        this.selectedCategory = null //La catégorie sélectionnée devient vide
        this.isDeleting = false;
      },
      close: function () { //Fonction de fermeture des modals
        this.isDeleting = false;
        this.isUpdating = false;
        this.selectedCategory = null;
      },
      showModalUpdate(categ) { //Affiche le composant de modification
        this.selectedCategory = categ;
        this.isUpdating = true;
      },
      updateCateg: function (obj) { //met à jour une catégorie
        updateCategory(obj.Id, obj.Label).then(() => {
          this.getListOfCateg();
        })
        this.selectedCategory = null
        this.isUpdating = false;
      },
    }
  }
</script>

<style scoped>
  .categ-creation {
    width: 100%;
    font-size: 20px;
    text-align:center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .categ-creation button {
    background-color: #28a745;
    border-color: #28a745;
    color:white;
  }
    .categ-creation button:hover {
      transform: scale(1.1);
    }

  .card .card-object .header {
    height: 60%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .container-categ {
    max-height: 100%;
    overflow: auto;
  }

  .card-object {
    height: 100%;
    width: 100%;
  }

  .card {
    width: 300px;
    height: 200px;
    background: none;
    border: 1px solid #dcdfe6;
    background: linear-gradient(#f4f5f8,#f1f3f6);
    margin-top: 2%;
  }


  .edit {
    background-color: #007bff;
    border-color: #007bff;
  }

  .edit:disabled {
      background-color: gray;
      border: none;
  }

  .management button:not(:disabled):hover {
    font-size: 22px;
  }

  .list li {
    float: left;
    margin-left: 5%;
  }

  .trash {
    background-color: #dc3545;
    border-color: #dc3545;
  }

  .trash:disabled {
      background-color: gray;
      border: none;
  }

  .management {
    height: 40%;
    width: 100%;
    justify-content: space-around;
    align-items: center;
    display: flex;
    background: white;
    z-index: 1;
  }

    .management button {
      color: #fff;
      font-size: 20px;
      width: 20%;
    }
  .title {
    padding: 10px;
    background-color: #198754;
    color: white;
    word-break: break-word;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Adherent/CmsCateg.vue